import React, { useEffect, useState } from 'react';
import {
    ResponsiveContainer,
    PieChart,
    Pie,
    Cell,
    Tooltip,
    Legend,
} from 'recharts';
import axios from 'axios';
import { FiPieChart } from "react-icons/fi"; // Example icon

const outerRadius = 100;

const COLORS = {
    'Delhivery': '#8884d8',
    "Ecom Express": '#8dd1e1',
    'Amazon': '#82ca9d',
    'Bluedart': '#ffc658',
    'DTDC': '#0CBB7D',
    'COD': '#FF8042',
    'Prepaid': '#0CBB7D',
    'On-Time': '#0CBB7D',
    'Late': '#FF8042',
};

const OverviewGraphSection = ({ selectedUserId }) => {
    const [graphData, setGraphData] = useState({
        couriersSplit: [],
        paymentMode: [],
        deliveryPerformance: [],
    });

    const fetchOverviewData = async () => {
        try {
            const [_, token] = document.cookie.split("=");
            const response = await axios.get(
                `${process.env.REACT_APP_BACKEND_URL}/dashboard/getOverviewGraphsData`,
                {
                    params: selectedUserId ? { userId: selectedUserId } : {},
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            if (response.data.success) {
                const {
                    couriersSplit,
                    paymentMode,
                    deliveryPerformance,
                } = response.data.data;

                setGraphData({
                    couriersSplit,
                    paymentMode,
                    deliveryPerformance:
                        deliveryPerformance.length > 0
                            ? deliveryPerformance
                            : [
                                { name: "On-Time", value: 80 },
                                { name: "Late", value: 20 },
                            ],
                });
            }
        } catch (error) {
            console.error("Error fetching overview graph data:", error.message);
        }
    };

    useEffect(() => {
        fetchOverviewData();
    }, []);
    const mapCourierName = (name) => name === 'Smartship' ? 'Bluedart' : name;
    const processChartData = (data) =>
        data.map(item => ({
            ...item,
            name: mapCourierName(item.name)
        }));
    const graphs = [
        { title: 'Couriers Split', data: processChartData(graphData.couriersSplit) },
        { title: 'Payment Mode', data: processChartData(graphData.paymentMode) },
        { title: 'Delivery Performance', data: processChartData(graphData.deliveryPerformance) },
    ];

    return (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4 z-10">
            {graphs.map((chart, index) => (
                <div
                    key={index}
                    className="bg-white text-gray-700 border border-gray-200 p-3 md:p-5 rounded-lg shadow-sm flex flex-col justify-between"
                >
                    <div className='flex justify-between items-center'>
                        <p className="lg:text-[14px] md:text-[14px] font-semibold">
                            {chart.title}
                        </p>
                        <p className="text-[10px] sm:text-[12px] text-gray-500">Last 30 days</p>
                    </div>

                    {chart.data.length === 0 ? (
                        <div className="flex flex-col justify-center items-center h-[200px] md:h-[270px] text-center text-gray-400">
                            <FiPieChart className="text-4xl mb-2" />
                            <p className="text-sm">No data available to display</p>
                        </div>
                    ) : (
                        <div className="h-[300px]">
                            <ResponsiveContainer width="100%" height="100%">
                                <PieChart>
                                    <Pie
                                        data={chart.data}
                                        dataKey="value"
                                        nameKey="name"
                                        cx="50%"
                                        cy="50%"
                                        outerRadius={outerRadius}
                                        innerRadius={outerRadius - 40}
                                        paddingAngle={2}
                                        stroke="#fff"
                                    >
                                        {chart.data.map((entry, i) => (
                                            <Cell
                                                key={`cell-${i}`}
                                                fill={COLORS[entry.name] || '#ccc'}
                                            />
                                        ))}
                                    </Pie>
                                    <Tooltip
                                        contentStyle={{
                                            backgroundColor: 'white',
                                            color: 'black',
                                            borderRadius: '6px',
                                            border: '1px solid #ccc',
                                            padding: '5px 9px',
                                            fontSize: '13px',
                                        }}
                                    />
                                    <Legend
                                        wrapperStyle={{ fontSize: '10px' }}
                                        formatter={(value) => (
                                            <span style={{ color: '#2d054b' }}>{value}</span>
                                        )}
                                    />
                                </PieChart>
                            </ResponsiveContainer>
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
};

export default OverviewGraphSection;